import React from "react";
import { NavLink } from "react-router-dom";
import "./layout.css";

const Linkdiv = ({ to, title, icon, className, onClick }) => {
  return (
    <NavLink className={`${className} dash-link`} to={to} onClick={onClick}>
      {icon}
      {title}
    </NavLink>
  );
};

export default Linkdiv;
